// import { useMutation, useQuery } from "@tanstack/react-query";
import { useSnackbar } from '../Stateless/SnackBarProvider';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useItemSubCategoryApi } from '../../hooks/useItemSubCategory';
import { useApi } from '../../hooks/useApi';
import {
  CreateItemSubCategoryRequest,
} from '../../client-sdk';

export const useItemSubCategoryAdd = () => {
  const { addItemSubCategory } = useApi();
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();

  return useMutation({
    mutationFn: (itemSubCategoryData: CreateItemSubCategoryRequest) =>
      addItemSubCategory(itemSubCategoryData),
    onSuccess: (response: any) => {
      queryClient.invalidateQueries({ queryKey: ['itemSubCategories'] });
      showMessage(response?.message || 'Store created successfully', 'success');
    },
    onError: (error: any) => {
      console.error('Error adding category:', error?.response?.data?.message);
      showMessage(
        error.response?.data?.message || 'Failed to create Store',
        'error'
      );
    },
  });
};

export const useEditItemSubCategory = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { editItemSubCategory } = useApi();

  return useMutation({
    mutationKey: ['editItemSubCategory'],
    mutationFn: ({
      id,
      data,
    }: {
      id: string;
      data: CreateItemSubCategoryRequest;
    }) => editItemSubCategory(id, data),
    onSuccess: (response: { message?: string }) => {
      showMessage(
        response?.message || 'Item Sub Category Updated successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['itemSubCategories'],
        exact: false,
      });
    },
    onError: (error: Error) => {
      showMessage(
        error.message || 'Failed to update the Item Sub Category',
        'error'
      );
    },
  });
};

export const usePatchItemSubCategory = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { getToggleStatus } = useItemSubCategoryApi();

  return useMutation({
    mutationKey: ['PatchSubAdmin'],
    mutationFn: ({ id, data }: { id: string[]; data: any }) =>
      getToggleStatus({ id, status: data.status }),
    onSuccess: () => {
      showMessage('Item Sub Category blocked successfully', 'success');
      queryClient.invalidateQueries({
        queryKey: ['itemSubCategories'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.detail?.[0]?.type ||
          'Failed to block the Item Sub Category',
        'error'
      );
    },
  });
};

export const useDeleteItemSubCategory = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { deleteItemSubCategory } = useItemSubCategoryApi();

  return useMutation({
    mutationKey: ['deleteItemSubCategory'],
    mutationFn: (id: string) => deleteItemSubCategory(id),
    onSuccess: (response: { message?: string }) => {
      showMessage(
        response?.message || 'Item Sub Category deleted successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['itemSubCategories'],
        exact: false,
      });
    },
    onError: (error: Error) => {
      showMessage(
        error.message || 'Failed to delete the Item Sub Category',
        'error'
      );
    },
  });
};


type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
};

export const useAllItemSubCategory = (queryParams: Params) => {

   
  const { getAllItemSubCategory } = useItemSubCategoryApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['itemSubCategories', queryParams],
    queryFn: () => {
      return getAllItemSubCategory(queryParams);
    },
  });


  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch
  };
};

// export const useEditSubAdmin = () => {
//   const queryClient = useQueryClient();
//   const { showMessage } = useSnackbar();
//   const { editSubAdmin } = useSubAdminApi();

//   return useMutation({
//     mutationKey: ["EditSubAdmin"],
//     mutationFn: ({ id, data }: { id: string; data: any }) =>
//       editSubAdmin(id, data ),
//       onSuccess: (response : any) => {
//       showMessage(response?.message || "SubAdmin Updated successfully", "success");
//       queryClient.invalidateQueries({
//         queryKey: ['getSubAdmin'],
//         exact: false,
//       });
//     },
//     onError: (error: any) => {
//       showMessage(
//         error.response?.data?.detail?.[0]?.type || "Failed to update the SubAdmin",
//         "error"
//       );
//     },
//   });
// };
